import Web3 from 'web3';

import { IAuctionHouseTransactionConfiguration } from 'models/web3Singleton/i-auction-house-transaction-configuration.interface';

import { AUCTION_HOUSE_ABI } from 'constants/abi/auction-house-abi.constant';
import { NETWORK_SETTINGS } from 'constants/network.constant';

import { BaseWeb3Service } from './base-web3.service';

/**
 * Service for handling auction house contract interactions
 * Manages bidding operations on the auction house
 */
export class AuctionHouseService extends BaseWeb3Service {
  private readonly auctionHouseAbi = AUCTION_HOUSE_ABI;
  private readonly auctionHouseAddress = NETWORK_SETTINGS.AUCTION_HOUSE.ADDRESS;
  private readonly auctionHouseContract: any;

  constructor(web3: Web3, torusProvider?: any) {
    super(web3, torusProvider);
    this.auctionHouseContract = this.createContract(this.auctionHouseAbi, this.auctionHouseAddress);
  }

  /**
   * Places a bid on an auction using main currency
   */
  async bid(configuration: IAuctionHouseTransactionConfiguration): Promise<void> {
    const gasPrice = await this.getGasPrice();

    await this.updateNetwork();

    await this.auctionHouseContract.methods
      .bid(configuration.auctionId, configuration.amount)
      .send({ from: configuration.walletAddress, gasPrice })
      .on('transactionHash', (hash: string) => configuration.onTransactionHash(hash))
      .on('confirmation', (blocks: number) => this.isConfirmed(blocks) && configuration.onSuccess());
  }

  /**
   * Places a bid on an auction using stablecoin
   */
  async stableBid(configuration: IAuctionHouseTransactionConfiguration): Promise<void> {
    const gasPrice = await this.getGasPrice();

    await this.updateNetwork();

    await this.auctionHouseContract.methods
      .bidStable(configuration.auctionId, configuration.amount)
      .send({ from: configuration.walletAddress, gasPrice })
      .on('transactionHash', (hash: string) => configuration.onTransactionHash(hash))
      .on('confirmation', (blocks: number) => this.isConfirmed(blocks) && configuration.onSuccess());
  }
}
